const checkIsURLAbsolute = (url) => /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(url);
export {
  checkIsURLAbsolute
};
//# sourceMappingURL=checkIsURLAbsolute.mjs.map